import React, { Fragment } from 'react'
import Session from '../services/Session'
import { base } from "../fire";
import { Spinner } from '@blueprintjs/core'
import logo from '../assets/logo.png'
import session from '../services/Session'
import Header from '../components/publicResults/Header'
import GeneralResults from '../components/publicResults/GeneralResults'
import BarResults from '../components/publicResults/BarResults'
import "../assets/components/Result.css";
import FadeIn from 'react-fade-in'
import AgeResults from '../components/publicResults/AgeResults';
import HoursOutCovid from '../components/publicResults/HoursOutCovid';
import HoursDuringCovid from '../components/publicResults/HoursDuringCovid';
import HoursR5 from '../components/publicResults/HoursR5';
import HoursR1 from '../components/publicResults/HoursR1';
import Feedbacks from '../components/Results/common/FeedbacksContainer'
import { changeLanguage } from "utlis/translations/i18n";




class PrivateResults extends React.Component {
    constructor(props) {
        super(props);
        this.state = { session: null, instances: [], loading: true };
        this.sessionId = this.props.match.params.id;
    }

    handleFormatResults = () => {
        let formatedResults = session.getResultsForSession(this.state.session, this.state.instances)
        this.setState({ formatedResults, loading: false })
    }

    componentDidMount() {
        /**
         * TODO: Check if we don't have the same issue that we had on user
         * (because we set sessionId in constructor and we need a refresh to update the value)
         */
        Session.getSessionByIdAndAuthID(this.sessionId).then(session => {
            if (!session) return this.setState({ loading: false, session: null });
            this.setState({ session });
            if (session.metadata.language) {
                changeLanguage(session.metadata.language);
              }
            this.syncSessionInstances = Session.syncSessionInstances(session.id, {
                context: this,
                state: "instances",
                asArray: true,
                then: () => {
                    this.handleFormatResults()
                }
            });
        });

        document.body.style.background = "#080808";
        // document.body.style.background =
        //     "-webkit-linear-gradient(to right, #232526, #414345)";
        // document.body.style.background =
        //     "linear-gradient(to right, #232526, #414345)";
    }

    componentWillUnmount() {
        document.body.style.background = null;

        if (this.syncSessionInstances)
            base.removeBinding(this.syncSessionInstances);
    }


    render() {
        if (this.state.loading) {
            return (
                <div style={{ marginTop: "50px" }}>
                    <Spinner size={200} />
                </div>)
        }

        if (this.state.instances && this.state.session) {
            const { session, formatedResults } = this.state
            const {
                data,
                metadata } = session
            let totalVotes = 0
            if (formatedResults && formatedResults[0]) {
                formatedResults[0].results.forEach((res) => {
                    totalVotes = totalVotes + res.points
                })
            }

            let feedbacks = Session.getFeedbackAnswersForSession(this.state.session, this.state.instances);

            return (
                <div>
                    <div className="context text-center margin-top-medium vs-container-personal-questions">
                        <div className='logo-container'>
                            <img src={logo} alt="logo" className='logo-large' />  &nbsp; &nbsp;
                                <span className='logo-title-large'>VisualSense</span>
                        </div>
                    </div>
                    {metadata &&
                        <Fragment>
                            {totalVotes !== 0 ?
                                <FadeIn>
                                    <Header
                                        title={metadata.name}
                                        context={metadata.context}
                                        votesAmount={totalVotes}
                                    />
                                </FadeIn>
                                :
                                ''
                            }

                            {formatedResults &&
                                <Fragment>
                                    <hr />
                                    <FadeIn className='margin-top-large'>
                                        <BarResults
                                            results={formatedResults}
                                            sequences={data.sequences}
                                        />
                                    </FadeIn>
                                    <hr className='margin-bottom-large' />
                                    {formatedResults.slice(0).reverse().map((results, i) => {
                                        let descendingResults = results.results.sort((a, b) => {
                                            if (a.points > b.points) return -1;
                                            if (a.points < b.points) return 1;
                                            return 0;
                                        })
                                        return (
                                            <FadeIn key={i}>
                                                <GeneralResults
                                                    key={i}
                                                    sequence={data.sequences.find(sequence => sequence.id === results.sequenceId)}
                                                    results={descendingResults}
                                                />
                                            </FadeIn>
                                        )
                                    }
                                    )}
                                    <AgeResults
                                        results={formatedResults}
                                        sequences={data.sequences}
                                    />

                                    <div className="displayNoneMobile">
                                        <hr className='margin-top-large margin-bottom-large' />
                                        <HoursOutCovid
                                            results={formatedResults}
                                            sequences={data.sequences}
                                        />
                                        <hr className='margin-top-large margin-bottom-large' />
                                        <HoursDuringCovid
                                            results={formatedResults}
                                            sequences={data.sequences}
                                        />
                                        <hr className='margin-top-large margin-bottom-large' />
                                        <HoursR5
                                            results={formatedResults}
                                            sequences={data.sequences}
                                        />
                                        <hr className='margin-top-large margin-bottom-large' />
                                        <HoursR1
                                            results={formatedResults}
                                            sequences={data.sequences}
                                        />
                                        <hr className='margin-bottom-large margin-top-large' />
                                        <Feedbacks
                                            feedbacks={feedbacks}
                                        />
                                    </div>
                                    <br /><br />

                                </Fragment>
                            }
                        </Fragment>
                    }
                </div>
            )
        }


    }
}

export default PrivateResults
